import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import jwtService from 'app/services/jwtService';
import { selectors as modeSelectors } from 'app/store/modeSlice';

export const useOptions = () => {
  const currentMode = useSelector(modeSelectors.selectModeType);

  return useMemo(
    () => ({
      transports: ['websocket'],
      path: '/ws/',
      // auth callback is invoked before each connect/reconnect attempt
      auth: (callback) => {
        // This tab's own token: localStorage may hold another tab's session.
        const token = jwtService.getOwnAccessToken();
        callback({
          token: token ? `Bearer ${token}` : '',
          mode: currentMode,
        });
      },
      reconnection: true,
      reconnectionAttempts: 20,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
    }),
    [currentMode]
  );
};
